export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-xbox-69037f080ee10518a7d2e9fd61d68d0e.svg";